module.exports = __webpack_public_path__ + "public/1.0.1_701555/img/default-chat.230d47f6.png";